var map = {
	"./deco.gif": 547,
	"./dish.webp": 927,
	"./jajang.mp4": 355,
	"./jajang.webp": 228,
	"./jjambbong.webp": 333,
	"./korean.webp": 831,
	"./skills/dish.webp": 622,
	"./tongfei.png": 901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 347;